/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-02-14 17:35:17
 * @LastEditors: Zhanyu Shen
 * @LastEditTime: 2022-04-15 16:52:53
 */
import { handleJson } from '../utils/templatejsonUtils';
import RenderSubscribe from '../subscribe/renderSubscribe';
import { checkHasHightFrameByPosition, getHightFrameLengthByPosition } from '../utils/renderUtils';
import { BASICTYPE_ENUM, LengthType, BASICRENDER_TYPE } from '../utils/enum';
import { TOPHIGHTFRAMESEPARATEDLENGTH } from '../utils/kitchenConfig';
class RotateHideMesh {
    constructor(templateJson, scene, bottomRenderEngine, camera, distance) {
        this.XNeedHideMeshIdList = [];
        this.P2XNeedHideMeshIdList = [];
        this.hideL1calloutLines = false;
        this.hideL3calloutLines = false;
        const { XNeedHideMeshIdList, P2XNeedHideMeshIdList } = handleJson(templateJson);
        this.XNeedHideMeshIdList = XNeedHideMeshIdList;
        this.P2XNeedHideMeshIdList = P2XNeedHideMeshIdList;
        this.scene = scene;
        this.bottomRenderEngine = bottomRenderEngine;
        this.templateJson = templateJson;
        this.subscribe = new RenderSubscribe(templateJson, this.scene);
        this.subscribe.subscribe('hideL1', this.hidel1.bind(this));
        this.subscribe.subscribe('hideL3', this.hidel3.bind(this));
        this.subscribe.subscribe('showAll', this.showAll.bind(this));
        this.camera = camera;
        this.distance = distance;
        this.setHideMeshArr(templateJson);
    }
    // 获取隐藏mesh的id
    get getAllHideMeshIdList() {
        return [...this.XNeedHideMeshIdList, ...this.P2XNeedHideMeshIdList];
    }
    // 恢复隐藏的mesh
    resetHideMeshId() {
        // online台面不会恢复
        // this.getAllHideMeshIdList?.forEach((item) => {
        //   this.setMeshStatus(this.scene.getMeshByName(item), true);
        // });
        this.showAll();
    }
    dispatch(immediatelyUpdate) {
        this.subscribe.dispatch(this.camera, this.distance, immediatelyUpdate);
    }
    // 隐藏及显示  后续台面及踢脚板的整改为XNeddHideMesh及P2XNeddHideMesh 区分需要隐藏的模型
    // 这样就不需要区分U型和H型 直接使用数组控制 两个mesh数组在rendertype里面的H及U里面控制
    // 台面的已经添加  踢脚板暂未修改
    /**
     * 隐藏l1的边
     */
    hidel1() {
        var _a;
        // 先隐藏柜体及门板水槽等的信息
        this.XNeedHideMeshIdList.forEach((item) => {
            this.setMeshStatus(this.scene.getMeshByName(item), false);
        });
        // 隐藏台面踢脚板等信息
        this.setMeshStatus(this.bottomRenderEngine.XNeddHideMesh, false);
        this.setMeshStatus(this.bottomRenderEngine.XNeedShowMesh, true);
        const bottomType = this.templateJson.bottom.type;
        if (bottomType === BASICRENDER_TYPE.U || bottomType === BASICRENDER_TYPE.U_S) {
            (_a = this.bottomRenderEngine.skirtingBoard) === null || _a === void 0 ? void 0 : _a.forEach((item, index) => {
                var _a;
                if (checkHasHightFrameByPosition(this.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)
                    && this.checkTopHightFrameIsSeparated(LengthType.Length1)) {
                    if (index < 6) {
                        item.mesh.setEnabled(false);
                    }
                    if (item.hide === 1) {
                        item.mesh.setEnabled(true);
                    }
                }
                else {
                    if (index < 3) {
                        item.mesh.setEnabled(false);
                    }
                    // if (index === 3) {
                    //   item.mesh.setEnabled(true);
                    // }
                    if (bottomType === BASICRENDER_TYPE.U_S && ((_a = this.templateJson.bottom.length2) === null || _a === void 0 ? void 0 : _a.frames.length) === 0) {
                        if (index === 3) {
                            item.mesh.setEnabled(false);
                        }
                    }
                    else if (index === 3) {
                        item.mesh.setEnabled(true);
                    }
                }
            });
        }
        this.hideL1calloutLines = true;
    }
    hidel3() {
        var _a, _b;
        this.P2XNeedHideMeshIdList.forEach((item) => {
            this.setMeshStatus(this.scene.getMeshByName(item), false);
        });
        this.setMeshStatus(this.bottomRenderEngine.P2XNeedShowMesh, true);
        this.setMeshStatus(this.bottomRenderEngine.P2XNeddHideMesh, false);
        if (this.templateJson.bottom.type === 'U' || this.templateJson.bottom.type === 'U_S') {
            (_b = (_a = this.bottomRenderEngine) === null || _a === void 0 ? void 0 : _a.skirtingBoard) === null || _b === void 0 ? void 0 : _b.forEach((item, index) => {
                var _a, _b;
                if (checkHasHightFrameByPosition(this.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)
                    && this.checkTopHightFrameIsSeparated(LengthType.Length1)) {
                    if (index > ((_a = this.bottomRenderEngine.skirtingBoard) === null || _a === void 0 ? void 0 : _a.length) - 6) {
                        item.mesh.setEnabled(false);
                    }
                    if (item.hide === 3) {
                        item.mesh.setEnabled(true);
                    }
                }
                else if (checkHasHightFrameByPosition(this.templateJson, BASICTYPE_ENUM.top, LengthType.Length3)
                    && this.checkTopHightFrameIsSeparated(LengthType.Length3)) {
                    if (item.hide === 3 || index < 2) {
                        item.mesh.setEnabled(true);
                    }
                    else {
                        item.mesh.setEnabled(false);
                    }
                }
                else {
                    if (index > ((_b = this.bottomRenderEngine.skirtingBoard) === null || _b === void 0 ? void 0 : _b.length) - 3 || index === 2) {
                        item.mesh.setEnabled(false);
                    }
                    if (item.hide === 3) {
                        item.mesh.setEnabled(true);
                    }
                }
            });
        }
        this.hideL3calloutLines = true;
    }
    showAll() {
        var _a, _b;
        // 展示全部的模型  视角正常情况
        [...this.XNeedHideMeshIdList, ...this.P2XNeedHideMeshIdList].forEach((item) => {
            this.setMeshStatus(this.scene.getMeshByName(item), true);
        });
        // 取消台面的隐藏
        this.setMeshStatus([...this.bottomRenderEngine.P2XNeddHideMesh, ...this.bottomRenderEngine.XNeddHideMesh], true);
        this.setMeshStatus(this.bottomRenderEngine.commonNeedHideMesh, false);
        // 取消踢脚板的隐藏
        (_a = this.bottomRenderEngine.skirtingBoard) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            item.mesh.setEnabled(true);
        });
        if (this.templateJson.bottom.type === 'U' || this.templateJson.bottom.type === 'U_S') {
            // 如果是U型需要展示正常的台面 将其他的两个台面隐藏掉
            (_b = this.bottomRenderEngine.skirtingBoard) === null || _b === void 0 ? void 0 : _b.forEach((item, index) => {
                if (checkHasHightFrameByPosition(this.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)) {
                    if (item.hide) {
                        item.mesh.setEnabled(false);
                    }
                }
                else if (index === 3 || index === 4) {
                    item.mesh.setEnabled(false);
                }
            });
        }
        this.hideL1calloutLines = false;
        this.hideL3calloutLines = false;
    }
    checkTopHightFrameIsSeparated(lengthNum) {
        const bottomLengthJson = this.templateJson.bottom[lengthNum];
        const bottomLength = Number(bottomLengthJson === null || bottomLengthJson === void 0 ? void 0 : bottomLengthJson.length);
        const topLengthJson = this.templateJson.top[lengthNum];
        const topLength = Number(topLengthJson === null || topLengthJson === void 0 ? void 0 : topLengthJson.length);
        if ((topLength - bottomLength)
            - getHightFrameLengthByPosition(this.templateJson, BASICTYPE_ENUM.top, lengthNum) > TOPHIGHTFRAMESEPARATEDLENGTH) {
            return true;
        }
        return false;
    }
    /**
     * 设置mesh的显隐
     * @param meshArr mesh数组  或者单独mesh
     * @param isShow 设置mesh的状态
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    setMeshStatus(meshArr, isShow) {
        if (!meshArr)
            return;
        if (Array.isArray(meshArr)) {
            meshArr.forEach((item) => {
                if (item) {
                    item.setEnabled(isShow);
                }
            });
        }
        else {
            meshArr.setEnabled(isShow);
        }
    }
    // 设置需要隐藏的数组，在切换门板的时候需要立即执行隐藏操作
    setHideMeshArr(templateJson) {
        const { XNeedHideMeshIdList, P2XNeedHideMeshIdList } = handleJson(templateJson);
        this.XNeedHideMeshIdList = XNeedHideMeshIdList;
        this.P2XNeedHideMeshIdList = P2XNeedHideMeshIdList;
        this.dispatch(true);
    }
}
export default RotateHideMesh;
